module.exports = __webpack_public_path__ + "static/media/error_buy.861e05aa.png";